import { useRef ,useState, useEffect } from 'react';
import Flatpickr from 'react-flatpickr';
import { format } from 'date-fns';
import fr from "date-fns/locale/fr/";

import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/themes/material_blue.css"
import MDInput from "dashboard/components/MDInput";
import { Icon } from '@mui/material';

/* eslint-disable */
const svgElement ='<svg viewBox="0 0 1024 1024" focusable="false" data-icon="swap-right" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M873.1 596.2l-164-208A32 32 0 00684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z"></path></svg>'

const DatePickers = (props) => {

    const refPicker = useRef();
    const [pickedValue, setPickedValue] =  useState('');
    
    const clearDate = () => {
      setPickedValue('')
      refPicker.current.flatpickr.clear()
    }
    
    
    const config = { 
      minDate: "1950-01-01", 
      // altInput: true,
      altFormat: "F j, Y",
      dateFormat: "d M y",
      // wrap: true,
      altInputClass: 'hide',
      mode: props.type,
      // allowInput: true,
      // parseDate: (datestr, format) => {
        
      //   // return moment(datestr, format, true).toDate();
      // },
      /* eslint-disable */
      // formatDate: (date, formatdate, locale) => {
      //   // locale can also be used
      //   const newDateFormat = format(date, 'dd MMM yyyy', {locale:fr}) 
      //   setPickedValue(newDateFormat);
      //   console.log(newDateFormat)
      //   return newDateFormat;
      // },
      onValueUpdate: function(selectedDates, dateStr, instance) {
        const newDateFormat = selectedDates?.length > 0 ? selectedDates.map( date => format(date, 'dd MMM yyyy', {locale:fr})) :'';
        selectedDates?.length > 0 && setPickedValue(newDateFormat?.join(config.mode === "range" ? ' to ' : ', '));
       },
    }
    
    useEffect(() => {}, [pickedValue]);

    return (
        <><Flatpickr
        {...props}
        render={({ defaultValue, value, ...props }, ref) => <MDInput {...props}
          type="text" label="birthdate" required size="medium" style={{width:"calc(100% - 35px)"}}
          defaultValue={defaultValue}
          value={pickedValue}
          ref={ref}
          data-input />}
        options={config}
        ref={refPicker} />
        <Icon sx={{ cursor: "pointer", m:.6 }} fontSize="medium"
          onClick={clearDate} data-clear>cancel
        </Icon></>
      )
}

export default DatePickers